import './ProductRating.less';
import { Product } from '../../models/Product';
import Icon from '../icon/Icon';
import { IconId } from '../icon/icons';
import { useMemo } from 'preact/hooks';
import { useTranslation } from '../../hooks/useTranslation';

export type ProductRatingProps = Pick<Product, 'ratingCount' | 'ratingValue'>;
type StarFulfillment = 'empty' | 'medium' | 'full';

const ProductRating = ({ ratingCount, ratingValue }: ProductRatingProps) => {
    const { t } = useTranslation();

    const hasRatings =
        !!ratingCount &&
        ratingCount > 0 &&
        !!ratingValue &&
        Number.isFinite(ratingValue);

    const stars = useMemo<StarFulfillment[]>(() => {
        if (!hasRatings) {
            return [];
        }
        const result: StarFulfillment[] = [];
        for (let i = 0; i < 5; i += 1) {
            if (ratingValue <= i + 0.25) {
                result.push('empty');
            } else if (ratingValue > i + 0.25 && ratingValue < i + 0.75) {
                result.push('medium');
            } else {
                result.push('full');
            }
        }
        return result;
    }, [ratingValue]);
    const getIconForStar = (star: StarFulfillment): IconId => {
        switch (star) {
            case 'empty':
                return 'star-outline';
            case 'medium':
                return 'star-half';
            case 'full':
                return 'star';
        }
    };

    return stars.length > 0 ? (
        <div
            className={`bri-ProductRating`}
            title={
                ratingCount === 1
                    ? t('RATING_SUMMARY_ONE', { rating: ratingValue ?? 0 })
                    : t('RATING_SUMMARY_MANY', {
                          rating: ratingValue ?? 0,
                          count: ratingCount ?? 0
                      })
            }
        >
            {stars.map(star => (
                <Icon iconId={getIconForStar(star)} size="x-small" />
            ))}
        </div>
    ) : (
        <span></span>
    );
};

export default ProductRating;
